import * as React from "react";

import classNames from "classnames/bind";

import styles from "./HeaderBurgerMenuButton.module.scss";

const cx = classNames.bind(styles);

const HeaderBurgerMenuButton = ({
    onClick,
}: {
    onClick: (event: React.MouseEvent<HTMLButtonElement> | Event) => void;
}) => {
    return (
        <button onClick={onClick} role="button" className={cx("burgerMenu")}>
            <div className={cx("burgerButton")}>
                <span className={cx("line", "line1")}></span>
                <span className={cx("line", "line2")}></span>
                <span className={cx("line", "line3")}></span>
            </div>
        </button>
    );
};

export default HeaderBurgerMenuButton;
